module.exports = __webpack_public_path__ + "static/img/newFood12.487f4c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood12.png
// module id = yMAJ
// module chunks = 2